import React, { memo, useCallback, useRef, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { message } from 'antd';
import classNames from 'classnames';
import styles from './WallpaperPath.module.less';
import { PCStoreJsBridge } from '../../../nativeapi';
import { logging } from '../../../actions/log';
import Toast from '../../../components/Toast/Toast';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(() => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);

  const [pathInfo, setPathInfo] = useState({});
  const [pathValue, setPathValue] = useState('D:LeStoreDownloadWallpaper');
  const inputRef = useRef();

  useEffect(() => {
    getWallpaperDPathFunc();
  }, []);

  // 获取下载地址
  const getWallpaperDPathFunc = useCallback(() => {
    PCStoreJsBridge.getWallpaperDPath({}).then(ret => {
      if (ret && ret.defpath) {
        setPathInfo(ret);
        setPathValue(ret.workpath);
      }
    });
  }, []);

  // 设置下载路径
  const submitDownloadPath = useCallback(() => {
    const matchStrD = /^[(\u4e00-\u9fa5)|(0-9)|(a-z)|(A-Z)|(_)|( )|(\\)|(:)]+$/;
    // 设置下载路径
    const DownLoadPath = inputRef.current.value;
    if (!DownLoadPath.match(matchStrD)) {
      message.info('下载目录，请不要选择有特殊字符的文件夹');
      return;
    }
    // 设置下载路径
    PCStoreJsBridge.setWallpaperDPath(DownLoadPath).then(
      data => {
        if (data.code === 0) {
          Toast.success({
            content: '壁纸下载路径，设置成功！',
          });
        } else {
          let msg = '壁纸下载路径，设置失败！';
          if (data.code === 111) {
            msg = '壁纸下载路径，盘符不存在！';
          } else if (data.code === 110) {
            msg = '壁纸下载路径，磁盘空间不足！';
          }
          setPathValue(pathInfo.defpath);
          Toast.error({ content: msg });
        }

        // 点击 打开选择下载文件路径
        dispatch(
          logging({
            category: 'R',
            action: 'Check_Path',
            label: '',
            param2: {
              source: 'Setting',
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              type: '2', // 0: 普通安装  1：静默安装  2:壁纸下载路径
              status: data.code === 0,
            },
          }),
        );
      },
      err => {
        setPathValue(pathInfo.defpath);
        Toast.error({
          content: '壁纸下载路径，设置失败！',
        });
      },
    );
  }, [inputRef, pathInfo, pathValue]);

  const handleBrowserFolder = useCallback(() => {
    // 选择下载路径
    const path = pathInfo.defpath || '';
    PCStoreJsBridge.browserFolder(path).then(res => {
      setPathValue(res.DownLoadPath);
      setTimeout(() => {
        submitDownloadPath();
      }, 100);
    });

    // 点击 打开选择下载文件路径
    dispatch(
      logging({
        category: 'C',
        action: 'Check_Path',
        label: '',
        param2: {
          source: 'Setting',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          type: '2', // 0: 普通安装  1：静默安装  2:壁纸下载路径
        },
      }),
    );
  }, [dispatch, logInfoData, pathInfo]);

  const handleOpenFolder = useCallback(
    path => {
      PCStoreJsBridge.openFolder(path);
      // 点击 打开文件路径
      dispatch(
        logging({
          category: 'C',
          action: 'Open_Path',
          label: '',
          param2: {
            source: 'Setting',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            type: 2, // 0: 普通安装  1：静默安装 2:壁纸下载路径
          },
        }),
      );
    },
    [dispatch, logInfoData],
  );
  const handleRecover = useCallback(() => {
    setPathValue(pathInfo.defpath);
    setTimeout(() => {
      submitDownloadPath();
    }, 100);
    // 点击 恢复默认文件路径
    dispatch(
      logging({
        category: 'C',
        action: 'Recover_Path',
        label: '',
        param2: {
          source: 'Setting',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          type: '2', // 0: 普通安装  1：静默安装 2:壁纸下载路径
        },
      }),
    );
  }, [pathInfo]);

  return (
    <>
      <div className="s_line">
        <div className="s_select_title">壁纸下载设置:</div>
        <div className="s_content">
          <div className="desc">将下载的壁纸保存在以下目录：</div>
          <div className="choose">
            <input
              type="text"
              className="value text-ellipsis"
              readOnly
              ref={inputRef}
              value={pathValue}
            />
            <div className="btn" onClick={handleBrowserFolder}>
              选择目录
            </div>
            <div
              className="open"
              onClick={() => {
                handleOpenFolder(pathValue);
              }}
            >
              打开
            </div>
          </div>
          <div className="recovery" onClick={handleRecover}>
            恢复默认目录
          </div>
        </div>
      </div>
    </>
  );
});
